<template>
  <div class="row">
    <div class="col-sm-3 col-sm-offset-2 col-xs-6"
         v-for="node in productNav"
         :key="node.id+'mobile-home'"
    >
      <div class="panel panel-default">
        <div class="panel-body text-center">
          <a class="h3 text-primary"
             :href="$catLink(node.seo_link)">
            {{ node.name }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "mobile-home-page-categories",
    computed:{
      productNav() {
        if (this.$store.state.persistent.navigation.length) {
          return this.$store.getters.getNav[0].menus;
        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ixcms/themes/gunoldcan/src/vue-src/top-level/mobile-home-page-categories.vue